import { Flex, Text } from '@zillow/constellation';
import { isToday } from 'date-fns';
import type { HeaderProps } from 'react-big-calendar';

const DateHeader = (props: HeaderProps) => {
  const [number, day] = props.label.split(' ');
  return (
    <Flex display="flex" flexDirection="column" marginY="xs">
      <Text fontType="finePrint" fontColor={isToday(props.date) ? 'blue600' : 'textMedium'}>
        {String(day).toUpperCase()}
      </Text>
      <Text fontType="h6" fontColor={isToday(props.date) ? 'blue600' : 'black'}>
        {number}
      </Text>
    </Flex>
  );
};

export default DateHeader;
